import { render, staticRenderFns } from "./basicDataList.vue?vue&type=template&id=71f0d85a&scoped=true&"
import script from "./basicDataList.vue?vue&type=script&lang=js&"
export * from "./basicDataList.vue?vue&type=script&lang=js&"
import style0 from "./basicDataList.vue?vue&type=style&index=0&id=71f0d85a&prod&scoped=true&lang=css&"
import style1 from "./basicDataList.vue?vue&type=style&index=1&id=71f0d85a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0d85a",
  null
  
)

export default component.exports